import { Component } from "@mna/react";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import Menu from "./Menu";
import i18next from 'i18next';
import { CookieBanner } from '@palmabit/react-cookie-law';
import { items, emergencyItems, travelAidItems } from "./menuitemlist";

var iOSSafari;
export default class Layout extends Component {
  componentDidMount() {
    var ua = window.navigator.userAgent;
    var iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
    var webkit = !!ua.match(/WebKit/i);
    iOSSafari = iOS && webkit && !ua.match(/CriOS/i);
  }

  state = {
    isHeaderMenuOpen: false,
		showing: false
  };

  closeHeaderMenu = () => {
    this.setState({ isHeaderMenuOpen: false });
    var ariaExp = document
      .getElementById("hamburger")
      .getAttribute("aria-expanded");
    // console.log("aria-expanded: ", ariaExp);
   if( ariaExp == "true"){
      //  document
      //     .getElementById("hamburger")
      //     .setAttribute("aria-expanded", "false")
   }else{
       document
          .getElementById("hamburger")
          .setAttribute("aria-expanded", "true");
          if(!this.state.isHeaderMenuOpen){
            document.getElementById("divLang").style.display="block"
            document.getElementById("divExitTriage").style.display="block"
            document.getElementById("hamburger").setAttribute("aria-label", i18next.t("Hamburger.hamburgerClose"))
            document.getElementById("hamburgerOption").setAttribute("aria-label", i18next.t("Hamburger.hamburgerClose"))
          }else{
            document.getElementById("divLang").style.display="none"
            document.getElementById("divExitTriage").style.display="none"
            document.getElementById("hamburger").setAttribute("aria-label", i18next.t("Hamburger.hamburgerMenu"))
            document.getElementById("hamburgerOption").setAttribute("aria-label", i18next.t("Hamburger.hamburgerMenu"))          }
      }
  };

  toggleHeaderMenu = () => {
    this.setState({ isHeaderMenuOpen: !this.state.isHeaderMenuOpen });
    var ariaExp = document
      .getElementById("hamburger")
      .getAttribute("aria-expanded");
    // console.log("aria-expanded: ", ariaExp);
    if( ariaExp == "true"){
      document.getElementById("hamburger").setAttribute("aria-expanded", "false")
      document.getElementById("divLang").style.display="none"
      document.getElementById("divExitTriage").style.display="none"
  }else{
      document
         .getElementById("hamburger")
         .setAttribute("aria-expanded", "true");
         if(!this.state.isHeaderMenuOpen){
           document.getElementById("divLang").style.display="block"
           document.getElementById("divExitTriage").style.display="block"
           document.getElementById("hamburger").setAttribute("aria-label", i18next.t("Hamburger.hamburgerClose"))
           document.getElementById("hamburgerOption").setAttribute("aria-label", i18next.t("Hamburger.hamburgerClose"))
         }else{
           document.getElementById("divLang").style.display="none"
           document.getElementById("divExitTriage").style.display="none"
           document.getElementById("hamburger").setAttribute("aria-label", i18next.t("Hamburger.hamburgerMenu"))
           document.getElementById("hamburgerOption").setAttribute("aria-label", i18next.t("Hamburger.hamburgerMenu"))
         }
     }
  };

  render() {
    const {
      type = "standard",
      withHeader = true,
      location,
      history,
      menuTitle,
      menuItems,
      menuCenter,
      children,
      footer,
      state,
      actions,
      setState,
      onRouteEnter,
    } = this.props;

    const { showing } = this.state;
    const { isHeaderMenuOpen } = this.state;
    if (isHeaderMenuOpen && state.triageRequest.isGetStarted) {
      this.closeHeaderMenu();
    } else {
      state.triageRequest.isGetStarted = false;
    }
    if (isHeaderMenuOpen && state.triageRequest.isHome) {
      this.closeHeaderMenu();
    } else {
      state.triageRequest.isHome = false;
    }
    return (
      <div
        className={`site ${iOSSafari ? "site-safari" : ""} site-layout-${type}${
          isHeaderMenuOpen ? " is-header-menu-open" : ""
        }`}
      >
        <CookieBanner
          styles={{
            banner: { backgroundColor: 'rgba(60, 60, 60, 0.8)' }
          }}
          cookieName="StandbyMDCookie"
          acceptButtonText={i18next.t("Cookies.acceptButtonText")}
          message={
          <div role="" className="w-col w-col-12 w-col-tiny-tiny-stack">
            <p className="w-form-label-justify">{i18next.t("Cookies.headingAtTop")} </p>
            <p><div id="btnDetails" aria-expanded="false"
             tabIndex="0" role="button"
             className="btnDetailView"
             aria-controls="cookieDetailExp"
              onClick={() => {
                this.setState({ showing: !showing });
                var btnDet = document.getElementById("btnDetails");
                if (!showing){
                  btnDet.setAttribute('aria-expanded', "true");
                }
                else {
                  btnDet.setAttribute('aria-expanded', "false");
                }
              }}
              onKeyDown={(e) => 
              { 
                if (e.key === " " || e.key === "Spacebar" || e.key === "Enter")
                {
                  this.setState({ showing: !showing });
                  var btnDet = document.getElementById("btnDetails");
                  if (!showing){
                    btnDet.setAttribute('aria-expanded', "true");
                  }
                  else {
                    btnDet.setAttribute('aria-expanded', "false");
                  }
                }
                if(e.key === "Tab"){
                  var firstFocusableEl=document.getElementById("btnDetails");
                  if(e.shiftKey && document.activeElement === firstFocusableEl){
                    document.getElementsByClassName("react-cookie-law-accept-btn")[0].focus()
                    e.preventDefault();
                  }else if( document.getElementById("btnDetails").getAttribute("aria-expanded") === "true" && e.key !== "Shift"){
                    document.getElementById("cookieDetailExp").focus()
                      e.preventDefault();
                  }
                }
              }}
              ondblclick={()=>{
                var detailButton = document.getElementById("btnDetails");
                if(detailButton && detailButton.getAttribute("aria-expanded")!=='true'){
                var btnDetailsEl = document.getElementById("btnDetails");
                if (btnDetailsEl) btnDetailsEl.setAttribute('aria-label', i18next.t('Cookies.cookieDetailExpandable'));
              }}}
              >{i18next.t("Cookies.linkDetails")}</div></p>
            <div id="cookieDetailExp" className="w-col w-col-12 w-col-tiny-tiny-stack" tabIndex="0"
              onKeyDown={(e)=>{               
                if(e.key === "Tab"){
                  if(e.shiftKey){
                    document.getElementById("btnDetails").focus();
                    e.preventDefault();
                  }
                }
              }}
             style={{ display: (showing ? 'block' : 'none') }}>
              <div className="w-col w-col-12 w-col-tiny-tiny-stack">
                <div className="w-col w-col-6 w-col-tiny-tiny-stack"><p><b>{i18next.t("Cookies.whatCookieHeading")}</b></p></div>
              </div>
              <div className="w-col w-col-12 w-col-tiny-tiny-stack"><p className="w-form-label w-form-label-justify">{i18next.t("Cookies.whatCookiesAnswer")}</p></div>
              <div className="w-col w-col-12 w-col-tiny-tiny-stack">
                <div className="w-col w-col-12 w-col-tiny-tiny-stack"><p><b>{i18next.t("Cookies.cookieUsedOurSiteHeading")}</b></p></div>
                <div className="w-col w-col-12 w-col-tiny-tiny-stack consent-border">
                  <div className="column-2-consent w-col w-col-12 w-col-tiny-tiny-stack">
                    <div className="w-col w-col-2 w-col-tiny-tiny-stack"><b>{i18next.t("Cookies.strictlyNecessaryHeading")}</b></div>
                    <div className="w-col w-col-10 w-col-tiny-tiny-stack">
                      <div className="w-col w-col-12 w-col-tiny-tiny-stack consent-border-left">
                        <div className="w-col w-col-12 w-col-tiny-tiny-stack">{i18next.t("Cookies.strictCookiesHeading")}</div>
                        <div className="w-col w-col-11 w-col-tiny-tiny-stack"><p className="w-form-label-justify">{i18next.t("Cookies.strictCookiesDesc")}</p></div>
                      </div>
                      <div className="w-col w-col-12 w-col-tiny-tiny-stack consent-border-left consent-border-top">
                        <div className="w-col w-col-12 w-col-tiny-tiny-stack">{i18next.t("Cookies.performanceHeading")}</div>
                        <div className="w-col w-col-11 w-col-tiny-tiny-stack"><p className="w-form-label-justify">{i18next.t("Cookies.performanceDesc")}</p></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div><p>{i18next.t("Cookies.headingAtBottom")}</p></div>
              </div>
            </div>
          </div>}
          wholeDomain={true}
        />
        {!withHeader ? null : (
          <Header
            {...{
              menuTitle,
              menuCenter,
              menuItems,
              isHeaderMenuOpen,
              toggleHeaderMenu: this.toggleHeaderMenu,
              closeHeaderMenu: this.closeHeaderMenu,
            }}
          />
        )}
        <Body
          {...{
            location,
            onRouteEnter,
            footer: <Footer>{footer}</Footer>,
          }}
        >
          {children}
        </Body>
        {(location.pathname.includes("find-care-options/") ||
          location.pathname.includes("find-facility")) &&
          !location.pathname.includes("find-care-options/emergency-question") &&
          !location.pathname.includes(
            "find-care-options/telemedicine-result"
          ) &&
          !location.pathname.includes("find-care-options/house-visit-result") &&
          !location.pathname.includes(
            "find-care-options/concierge-care-result"
          ) &&
          !location.pathname.includes("find-care-options/done") && (
            <Menu
              {...{
                history,
                state,
                setState,
                actions,
                nextStepName: "questions",
                items:
                  state.triageRequest.emergency || state.isFacility || state.triageRequest.isFacilitySearch
                    ? emergencyItems
                    : state.isTravelAid2 && !state.triageRequest.isFacilitySearch
                    ? travelAidItems
                    : items,
              }}
            ></Menu>
          )}
      </div>
    );
  }
}
